import { Heading1 } from "@/components/podkit/typography/Headings";
import { Text } from "@/components/podkit/typography/Text";
import type { FC, ReactNode } from "react";

type AutomationsPageHeaderProps = {
    actions?: ReactNode;
};

export const AutomationsPageHeader: FC<AutomationsPageHeaderProps> = ({ actions }) => {
    return (
        <div className="flex min-w-0 items-center justify-between">
            <Heading1>Automations</Heading1>
            {actions}
        </div>
    );
};

// ---------------------------------------------------------------------------
// Legacy header (flag OFF) — preserved from main
// ---------------------------------------------------------------------------

export const AutomationsPageHeaderLegacy: FC<AutomationsPageHeaderProps> = ({ actions }) => {
    return (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-2">
            <div className="flex flex-col">
                <Heading1>Automations</Heading1>
                <Text className="text-content-base text-base">
                    Run parallel Automations across projects with Ona to automate, track, and report at scale.
                </Text>
            </div>
            {actions}
        </div>
    );
};
